import "core-js/modules/es.promise.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
//@ts-ignore
import { getPublicUser as getPublicUserAPI } from "@services/publicUserAPI";
import { defineStore } from "pinia";
import { ref } from "vue";
export var usePublicUserStore = defineStore("publicUserStoreId", () => {
  var publicUserId = ref(-1);
  var userEmail = ref("");
  var userPhone = ref("");
  var userSurname = ref("");
  var userName = ref("");
  var initPublicUser = _ref => {
    var {
      email,
      phone,
      surname,
      name,
      publicUserId: puId
    } = _ref;
    publicUserId.value = puId;
    userEmail.value = email;
    userPhone.value = phone;
    userSurname.value = surname;
    userName.value = name;
  };
  var resetPublicUserStore = () => {
    publicUserId.value = -1;
    userEmail.value = "";
    userPhone.value = "";
    userSurname.value = "";
    userName.value = "";
  };
  var getPublicUser = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
      var publicUser = yield getPublicUserAPI();
      initPublicUser(publicUser);
    } catch (err) {
      console.error(err);
    }
  });
  return {
    publicUserId,
    userEmail,
    userPhone,
    userSurname,
    userName,
    initPublicUser,
    resetPublicUserStore,
    getPublicUser
  };
});